import React from 'react';
import { Badge, Form } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import { TimelineStepEnum } from '../../../common/pokCore/validation/enums';
import { GetNoContractAdditionalInfoDto } from '../../../common/pokCore/autogenerated/pokApiClient';

interface NoContractSubItemProps {
  itemType: TimelineStepEnum;
  stepDefinitionId?: string;
  infos?: GetNoContractAdditionalInfoDto[];
  onChange?: (estimateItemId: string, checked: boolean) => void;
}

export const NoContractSubItem: React.FC<NoContractSubItemProps> = ({
  itemType,
  stepDefinitionId,
  infos,
  onChange,
}) => {
  const { t, tk } = useTranslation('projectLng');

  if (itemType !== TimelineStepEnum.CheckContractsCoverage || !infos?.length) {
    return null;
  }

  return (
    <div className="ms-4 mt-2 ps-3 border-start border-secondary border-2">
      {infos.map((info, key) => (
        <Form.Check
          key={key}
          type="checkbox"
          id={`no-contract-${stepDefinitionId}-${key}`}
          className="mb-0 text-muted"
          checked={info.checked}
          label={
            <>
              <small className="text-muted">
                <em>{info.text}</em>
              </small>
              <Badge className="ms-2" bg="info" pill>
                {t(tk.timeLine.manual)}
              </Badge>
            </>
          }
          onChange={e => onChange?.(info.estimateItemId, e.target.checked)}
        />
      ))}
    </div>
  );
};
